<template>
    <div class="revenue-point-summary">
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <h2 class="listing-title d-inline-block mb-0">Revenue Point Summary</h2>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <b-card no-body>
                <!-- HEADER -->
                <b-card-header class="border-0">
                    <b-row></b-row>
                </b-card-header>

                <!-- SEARCH INPUT -->
                <b-col cols="12">
                    <b-row class="d-flex align-items-center">
                        <b-col cols="12" md="6" class="d-md-flex">
                            <base-input
                            label="Search"
                            v-model="searchQuery"
                            v-on:input="debouncedHandler"
                            prepend-icon="fas fa-search"
                            placeholder="Search..."
                            >
                            </base-input>
                            <base-input label="Date" class="mx-4">
                                <el-date-picker
                                v-model="datePicked"
                                type="month"
                                format="yyyy-MM"
                                value-format="yyyy-MM"
                                @change="filterByDate($event)"
                                placeholder="Pick a month">
                                </el-date-picker>
                            </base-input>
                        </b-col>
                    </b-row>
                </b-col>

                <!-- TABLE LIST -->
                <div class="table-listings">
                    <el-table 
                        ref="multipleTable"
                        v-loading="isTableLoading"
                        :data="queriedData"
                        style="width: 100%;"
                        @selection-change="selectionChange"
                    >
                        <el-table-column
                            type="selection"
                            width="35"
                            fixed
                            class-name="double-line-label px-2"
                        ></el-table-column>
                        
                        <!-- NAME COLUMN -->
                        <el-table-column
                            prop="customer_name"
                            label="Customer"
                            min-width="200"
                            sortable
                        >
                            <template slot-scope="scope" v-if="scope.row.case_recognizes && scope.row.case_recognizes.case">
                                <p class="top-line">
                                    {{ scope.row.case_recognizes.case.prod_customer_name }}
                                </p>
                                <router-link class="text-primary bottom-line" :to="'/customerProfileDetails/' + scope.row.case_recognizes.case.prod_customer_id + '?active=overview'" target="_blank">
                                    {{ scope.row.case_recognizes.case.prod_customer_id }}
                                </router-link>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="Product Details"
                            min-width="200"
                        >
                            <template slot-scope="scope" v-if="scope.row.case_recognizes && scope.row.case_recognizes.case">
                                <template v-if="scope.row.case_recognizes.case.prod_type == 'mortgage' || scope.row.case_recognizes.case.prod_type == 'property'">
                                    <p class="top-line">
                                        {{ scope.row.case_recognizes.case.prod_details.property_mortgage.prod_pm_project_name }}
                                        
                                    </p>
                                    <p class="bottom-line">
                                        {{ scope.row.case_recognizes.case.prod_details.property_mortgage.prod_pm_property_type }}
                                        {{ scope.row.case_recognizes.case.prod_details.property_mortgage.prod_pm_unit_no }}
                                    </p>
                                </template>
                                <template v-else-if="scope.row.case_recognizes.case.prod_type == 'personal'">
                                    <p class="top-line">
                                        {{ scope.row.case_recognizes.case.prod_details.personal_loan.prod_pl_loan_agreement_rate | moneyFormatter }}
                                    </p>
                                </template>
                                <template v-if="scope.row.case_recognizes.case.prod_type == 'insurance'">
                                    <p class="top-line">
                                    </p>
                                    <p class="bottom-line">
                                    </p>
                                </template>
                                <p class="bottom-line">
                                    {{ scope.row.case_recognizes.case.prod_type }}
                                </p>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="Sales Value"
                            min-width="150"
                        >
                            <template slot="header" slot-scope="scope">
                                <span class="text-break">{{ scope.column.label }}</span>
                            </template>
                            <template slot-scope="scope">
                                <p class="top-line" v-if="scope.row.case_recognizes && scope.row.case_recognizes.comms_payout_summaries">
                                   RM {{ scope.row.case_recognizes.comms_payout_summaries[0].cps_develop_nett_price | moneyFormatter }}
                                </p>
                            </template>
                        </el-table-column>

                        <el-table-column
                            prop="channel_name"
                            label="Service Type / Leads Owner"
                            min-width="150"
                        >
                            <template slot="header" slot-scope="scope">
                                <span class="text-break">{{ scope.column.label }}</span>
                            </template>
                            <template slot-scope="scope">
                                <p class="top-line" v-if="scope.row.case_recognizes && scope.row.case_recognizes.comms_payout_summaries">
                                    {{ scope.row.case_recognizes.comms_payout_summaries[0].payout_distribution.service_type_code }}
                                </p>
                                <p class="bottom-line">
                                    {{ scope.row.channel_name }}
                                </p>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="Sales Revenue Point"
                            min-width="150"
                        >
                            <template slot="header" slot-scope="scope">
                                <span class="text-break">{{ scope.column.label }}</span>
                            </template>
                            <template slot-scope="scope">
                                <p class="top-line" v-if="scope.row.case_recognizes && scope.row.case_recognizes.comms_payout_summaries && scope.row.case_recognizes.comms_payout_summaries[0]">
                                  RM {{ scope.row.case_recognizes.comms_payout_summaries[0].cps_actual_total_revenue_point | moneyFormatter }}
                                </p>
                                <p class="bttom-line" v-if="scope.row.case_recognizes && scope.row.case_recognizes.comms_payout_summaries && scope.row.case_recognizes.comms_payout_summaries[0]">
                                    {{ scope.row.case_recognizes.comms_payout_summaries[0].cps_service_type_percentage | moneyFormatter }} %
                                </p>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="Sales"
                            min-width="200"
                        >
                            <template slot="header" slot-scope="scope">
                                <span class="text-break">{{ scope.column.label }}</span>
                            </template>
                            <template slot-scope="scope" v-if="scope.row.sales_team">
                                <p class="bottom-line">
                                    <b>SE -</b> {{ scope.row.sales_team.sales_executive.name || '-' }}
                                </p>
                                <p class="bottom-line">
                                    <b>Sales Manager -</b> {{ scope.row.sales_team.sales_manager.name || '-' }}
                                </p>
                                <p class="bottom-line">
                                    <b>Hub Manager -</b> {{ scope.row.sales_team.hub_manager.name || '-' }}
                                </p>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="Advisory Revenue Point"
                            min-width="150"
                        >
                            <template slot="header" slot-scope="scope">
                                <span class="text-break">{{ scope.column.label }}</span>
                            </template>
                            <template slot-scope="scope" v-if="scope.row.case_recognizes && scope.row.case_recognizes.comms_payout_summaries && scope.row.case_recognizes.comms_payout_summaries[1]">
                                <p class="top-line">
                                    RM {{ scope.row.case_recognizes.comms_payout_summaries[1].cps_actual_total_revenue_point | moneyFormatter }}
                                </p>
                                <p class="bttom-line" v-if="scope.row.case_recognizes && scope.row.case_recognizes.comms_payout_summaries && scope.row.case_recognizes.comms_payout_summaries[1]">
                                    {{ scope.row.case_recognizes.comms_payout_summaries[1].cps_service_type_percentage | moneyFormatter }} %
                                </p>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="Advisory"
                            min-width="200"
                        >
                            <template slot="header" slot-scope="scope">
                                <span class="text-break">{{ scope.column.label }}</span>
                            </template>
                            <template slot-scope="scope">
                                <template v-if="scope.row.case_recognizes">
                                    <p class="bottom-line" v-if="scope.row.case_recognizes.use_user2">
                                        <b>SSE -</b> {{ scope.row.case_recognizes.use_user2.name || '-' }}
                                    </p>
                                    <p class="bottom-line" v-if="scope.row.case_recognizes.use_user">
                                        <b>SSA -</b> {{ scope.row.case_recognizes.use_user.name || '-' }}
                                    </p>
                                </template>
                                <template v-if="scope.row.advisory_team && scope.row.advisory_team.hub_manager">
                                    <p class="bottom-line">
                                        <b>SSA Manager -</b> {{ scope.row.advisory_team.sales_manager.name || '-' }}
                                    </p>
                                    <p class="bottom-line">
                                        <b>Hub Manager -</b> {{ scope.row.advisory_team.hub_manager.name || '-' }}
                                    </p>
                                </template>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="Total Payout"
                            min-width="150"
                        >
                            <template slot="header" slot-scope="scope">
                                <span class="text-break">{{ scope.column.label }}</span>
                            </template>
                            <template slot-scope="scope">
                                <p class="top-line" v-if="scope.row.case_recognizes">
                                   RM {{ scope.row.case_recognizes.total_actual_revenue_point | moneyFormatter }}
                                </p>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </b-card>
        </b-container>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option, DatePicker } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import {
helperFunctionMixin,
notifyFunctionMixin,
axios,
services,
getHeader,
debounce,
swal
} from '@/assets/js/httpImports.js'
export default {
    mixins: [clientPaginationMixin],
    components: {
        BasePagination,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Select.name]: Select,
        [Option.name]: Option,
        [DatePicker.name]: DatePicker,
    },
    data() {
        return {
            isTableLoading: false,
            propsToSearch:['customer_name'],
            currentPage: 1,
            mode: 'listing',
            selectedRows: [],
            searchText: '',
            debouncedHandler: '',
            TableColumn:[{
                type: 'selection'
            }],
            tableData: [],
            datePicked: ''
        }
    },
    created() {
        this.getRevenuePointSummary();
    },
    mounted() {
        this.debouncedHandler = debounce(() => {
            this.getRevenuePointSummary();
        }, 500);
    },
    methods: {
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows
        },
        paginationChanged(page)
        {
            this.pagination.currentPage = page
        },
        getRevenuePointSummary()
        {
            axios.get(services.hub + 'hub_comms/case_recognize', {
                params: {
                    filter: this.searchText,
                    filter_dates: this.datePicked,
                },
                headers: getHeader()
            })
            .then(res => {
                this.tableData = res.data.data
                console.log('datea', this.tableData)
            })
            .catch(e => {
                this.isTableLoading = false
                this.errorFunction(e)
            })
        },
        filterByDate() {
            this.getRevenuePointSummary()
        },
    },
}
</script>